<template>
  <v-dialog v-model="localValue.visible" persistent width="500px">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn icon dark @click="localValue.visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Orden Domicilio</v-toolbar-title>
      </v-toolbar>
      <br/>
      <v-card-text>
        <!-- Total -->
        <v-row>
          <v-col>
            <v-text-field
              dense
              rounded
              label="Total"
              type="number"
              outlined
              prefix="$"
              readonly
              v-model="localValue.total"
            />
          </v-col>
        </v-row>

        <!-- Tipos de pago -->
        <div class="mb-3">
          <div class="text-subtitle-1 font-weight-bold mb-3">
            Selecciona el tipo de pago
          </div>

          <v-row v-if="tiposPagos.length">
            <v-col
              cols="6"
              v-for="tipo in tiposPagos"
              :key="tipo.intTipoPago"
            >
              <v-card
                outlined
                class="tipo-pago-card"
                :class="{
                  'tipo-pago-seleccionado':
                    tipoPagoSeleccionado === tipo.intTipoPago
                }"
                @click="seleccionarTipoPago(tipo)"
              >
                <v-card-text class="text-center pa-3">
                  <v-img
                    v-if="tipo.StrImagenPago"
                    :src="tipo.StrImagenPago"
                    contain
                    height="55"
                    class="mb-2"
                  />

                  <div class="font-weight-bold text-caption">
                    {{ tipo.strNombre }}
                  </div>

                  <v-icon
                    v-if="tipoPagoSeleccionado === tipo.intTipoPago"
                    color="primary"
                    class="mt-1"
                  >
                    mdi-check-circle
                  </v-icon>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <div v-else class="text-center grey--text py-4">
            No hay tipos de pago disponibles.
          </div>
        </div>

        <!-- Cliente paga con -->
        <v-row>
          <v-col>
            <v-text-field
              dense
              rounded
              label="CLIENTE PAGA CON"
              min="0"
              type="number"
              outlined
              @keypress="isFloat($event)"
              prefix="$"
              v-model="localValue.pagacon"
            />
          </v-col>
        </v-row>

        <!-- Cambio -->
        <v-row>
          <v-col>
            <v-text-field
              dense
              rounded
              label="CAMBIO"
              type="number"
              outlined
              prefix="$"
              readonly
              :value="cambio"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="primary"
          block
          @click="continuar"
          :disabled="
            cambio < 0 ||
            tipoPagoSeleccionado === null ||
            !tiposPagos.length
          "
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isFloat } from "../js/utilities";
import { Data } from "../controllers/DataController.js";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localValue: this.value,
      tiposPagos: [],
      tipoPagoSeleccionado: null,
    };
  },

  computed: {
    cambio() {
      const pagaCon = Number(this.localValue.pagacon) || 0;
      const total = Number(this.localValue.total) || 0;

      return Number((pagaCon - total).toFixed(2));
    },
  },

  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },

  async mounted() {
    await this.obtenerTiposPago();
  },

  methods: {
    isFloat,

    async obtenerTiposPago() {
      try {
        const data = new Data();
        const respuesta = await data.loadTipoPrecio(0);

        this.tiposPagos = respuesta || [];

        console.log("TIPOS DE PAGO:", this.tiposPagos);
      } catch (error) {
        console.error("Error al cargar tipos de pago:", error);
        this.tiposPagos = [];
      }
    },

    seleccionarTipoPago(tipo) {
      this.tipoPagoSeleccionado = tipo.intTipoPago;

      console.log("TIPO DE PAGO SELECCIONADO:", tipo);
    },

    continuar() {
      const tipoSeleccionado = this.tiposPagos.find(
        tipo => tipo.intTipoPago === this.tipoPagoSeleccionado
      );

      if (!tipoSeleccionado) {
        return;
      }

      this.$emit("continuar", {
        cambio: this.cambio,
        total: Number(this.localValue.total),
        pagaCon: Number(this.localValue.pagacon),
        intTipoPago: tipoSeleccionado.intTipoPago,
        strNombreTipoPago: tipoSeleccionado.strNombre,
        tipoPago: tipoSeleccionado,
      });
    },
  },
};
</script>

<style scoped>
.tipo-pago-card {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 12px;
  transition: all 0.2s ease;
  height: 100%;
}

.tipo-pago-card:hover {
  border-color: #58789e;
  background-color: #f4f7fa;
}

.tipo-pago-seleccionado {
  border-color: #113e75 !important;
  background-color: #e9eef4;
}
</style>